<div class="timer">
  <div class="timer-before" [@maskLeft]="{value: timerState, params: {duration: duration, delay: delay}}"></div>
  <div class="timer-line"
       [@line]="{value: timerState, params: {startAngle: startAngle, duration: duration}}"
       (@line.done)="timerDoneEvent($event)"
  ></div>
  <div class="timer-body">
    <ng-content></ng-content>
  </div>
  <div class="timer-after" [@maskRight]="{value: timerState, params: {duration: duration, delay: delay}}"></div>
</div>
